(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2150,5442,5223],{

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 45220:
/***/ (function(module) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 9695:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[mobileOrDesktop]/[hostname]/order",
      function () {
        return __webpack_require__(64497);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SafeSuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SafeSuspense__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5822);
/* harmony import */ var _SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function SafeSuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SafeSuspense__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 19060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SsgFallback; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59848);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80805);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function SsgFallback() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().loading)
        })
    });
};


/***/ }),

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8165);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Loading(props) {
    var height = props.height || 200;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        style: {
            height: height
        }
    });
};


/***/ }),

/***/ 75288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function SuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54731);
/* harmony import */ var _hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1626);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18899);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








function Button(props, ref) {
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loadingState = _$ref[0], setLoading = _$ref[1];
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var loading = props.loading || loadingState;
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), confirm = _$ref1[0], setConfirm = _$ref1[1];
    var overrideOnClickRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var darkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var onClick = function() {
        var _ref = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(props.disabled || loading)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!props.confirmText) {
                            _ctx.next = 9;
                            break;
                        }
                        if (!confirm) {
                            _ctx.next = 7;
                            break;
                        }
                        {
                            setConfirm(false);
                        }
                        _ctx.next = 9;
                        break;
                    case 7:
                        setConfirm(true);
                        return _ctx.abrupt("return");
                    case 9:
                        setLoading(true);
                        if (!overrideOnClickRef.current) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 13;
                        return overrideOnClickRef.current();
                    case 13:
                        _ctx.next = 21;
                        break;
                    case 15:
                        if (!props.onClick) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 18;
                        return props.onClick();
                    case 18:
                        _ctx.next = 21;
                        break;
                    case 20:
                        if (props.to) {
                            router.push(props.to);
                        }
                    case 21:
                        // check if button is mounted
                        if (buttonRef.current) {
                            setLoading(false);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var setOnClick = function(onClick) {
        overrideOnClickRef.current = onClick;
    };
    var _clickOnKey;
    (0,_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_clickOnKey = props.clickOnKey) !== null && _clickOnKey !== void 0 ? _clickOnKey : "none", function() {
        if (!props.disabled && !loading && props.clickOnKey) {
            onClick();
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, function() {
        return {
            onClick: onClick,
            setOnClick: setOnClick,
            click: onClick,
            focus: function() {
                if (buttonRef.current) {
                    buttonRef.current.focus();
                }
            }
        };
    });
    var style = props.disabled ? "disabled" : props.primary ? "primary" : props.danger ? "danger" : props.contrast ? "contrast" : "default";
    var size = props.small ? "small" : props.extraBig ? "extraBig" : props.big ? "big" : "default";
    var className = classnames__WEBPACK_IMPORTED_MODULE_5___default()({
        "inline-flex justify-center items-center shadow-sm rounded": true,
        "font-semibold": true,
        "transition ease-in-out duration-150": true,
        "focus:outline-none focus:ring-2 focus:ring-offset-2": true,
        "px-4 py-2 text-sm": size === "default",
        "px-4 py-1 text-sm": size === "small",
        "px-5 py-3 text-md": size === "big",
        "px-5 py-4 text-md": size === "extraBig",
        "cursor-not-allowed": props.disabled,
        "w-full": props.full,
        "!border-gray-100 text-gray-400": style === "disabled",
        "border-gray-100 text-gray-700": style === "default",
        "text-white": style === "primary" || style === "danger",
        "focus:ring-gray-300": style === "default",
        "focus:button-v3-primary": style === "primary",
        "focus:ring-red-500": style === "danger",
        "bg-gray-100 border-gray-100": style === "disabled" || style === "default",
        "bg-red-500 border-red-500": style === "danger",
        "button-v3-primary": style === "primary",
        "bg-gray-900 border-gray-900 text-white": style === "contrast" && !darkMode,
        "bg-white border-white text-gray-900": style === "contrast" && darkMode,
        "hover:bg-gray-200": !loading && style === "default" || style === "contrast" && darkMode && !loading,
        "hover:button-v3-primary": !loading && style === "primary",
        "hover:bg-red-400": !loading && style === "danger",
        "hover:bg-gray-300": style === "contrast" && !darkMode && !loading
    }, props.className);
    var _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
        ref: buttonRef,
        type: (_type = props.type) !== null && _type !== void 0 ? _type : "submit",
        form: "formId",
        disabled: props.disabled || loading,
        onClick: onClick,
        className: className,
        children: [
            !loading && props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(props.icon, {
                className: "-ml-0.5 mr-2 w-4",
                "aria-hidden": "true"
            }) : null,
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: "mr-3",
                color: style === "default" ? "gray" : "white"
            }) : null,
            confirm ? props.confirmText : props.children
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(Button));


/***/ }),

/***/ 97417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54731);




function TextSkeleton(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, type = param.type;
    var isDarkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            "animate-pulse rounded mb-1": true,
            "bg-slate-200": !isDarkMode,
            "bg-slate-600": isDarkMode,
            "h-3": type === "caption",
            "h-6": type === "title",
            "h-5": type === "subtitle" || type === "body",
            "w-full": !(className === null || className === void 0 ? void 0 : className.includes("w-"))
        }, className)
    });
};


/***/ }),

/***/ 18899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SpinnerLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function SpinnerLoading(props) {
    var color = props.color || "gray";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, {
            "h-5 w-5": !props.size || props.size === "sm",
            "h-4 w-4": props.size === "xs",
            "h-6 w-6": props.size === "md",
            "h-8 w-8": props.size === "lg",
            "h-10 w-10": props.size === "xl",
            "animate-spin": true,
            "text-white": color === "white",
            "text-gray-500": color === "gray",
            "text-blue-500": color === "blue" || color === "primary",
            "text-green-500": color === "green",
            "text-red-500": color === "red",
            "text-yellow-500": color === "yellow",
            "text-black": color === "black"
        }),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};


/***/ }),

/***/ 6879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        '\n  fragment checkoutV3CartPreferences on Preference {\n    menuId\n    cart {\n      websiteCoinsToSpend\n      items {\n        _id\n        amount\n        isOutOfStock\n        priceWithoutDiscounts: unitPrice(includeDiscount: false)\n        priceWithDiscounts: unitPrice(includeDiscount: true)\n        descriptionItems {\n          title\n          selections\n        }\n        outOfStockMessage\n        product {\n          _id\n          name\n          image {\n            _id\n            url: resizedURL(width: 300, height: 300, format: "webp")\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject()));


/***/ }),

/***/ 38279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment checkoutV3CouponPreferences on Preference {\n    websiteId\n    couponCode\n    cart {\n      couponCode\n      couponStatus {\n        errorMessage\n        couponId\n        name\n        discount\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject()));


/***/ }),

/***/ 14204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v3; }
});

// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./src/data/fragments/checkout/v3/cartFragment.main.ts
var cartFragment_main = __webpack_require__(6879);
// EXTERNAL MODULE: ./src/data/fragments/checkout/v3/couponFragment.main.ts
var couponFragment_main = __webpack_require__(38279);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/v3/deliveryFragment.main.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment checkoutV3DeliveryPreferences on Preference {\n    placeId\n    tableName\n    directions {\n      duration\n    }\n    address {\n      _id\n      address\n      addressSecondary\n      addressLine2\n      acceptsNoLine2\n      location\n      comment\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var deliveryFragment_main = ((0,lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./src/data/fragments/checkout/v3/paymentMethodFragment.main.ts
var paymentMethodFragment_main = __webpack_require__(39489);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/v3/pickupFragment.main.ts
function pickupFragment_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function pickupFragment_main_templateObject() {
    var data = pickupFragment_main_taggedTemplateLiteral([
        "\n  fragment checkoutV3PickupPreferences on Preference {\n    store {\n      _id\n      name\n      address {\n        address\n        addressLine2\n      }\n    }\n  }\n"
    ]);
    pickupFragment_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var pickupFragment_main = ((0,lib["default"])(pickupFragment_main_templateObject()));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/v3/profileFragment.main.ts
function profileFragment_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function profileFragment_main_templateObject() {
    var data = profileFragment_main_taggedTemplateLiteral([
        "\n  fragment checkoutV3ProfilePreferences on Preference {\n    sessionEmail\n    sessionPhone\n    sessionEmailHasAccount\n    user {\n      _id\n      name\n      email\n      phone\n      profile {\n        firstName\n        lastName\n      }\n    }\n  }\n"
    ]);
    profileFragment_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var profileFragment_main = ((0,lib["default"])(profileFragment_main_templateObject()));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/v3/scheduleFragment.main.ts
function scheduleFragment_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function scheduleFragment_main_templateObject() {
    var data = scheduleFragment_main_taggedTemplateLiteral([
        "\n  fragment checkoutV3SchedulePreferences on Preference {\n    timeLabel\n    time\n    dropOffType\n    deliverAt\n    store {\n      minimumAnticipationDays\n      availableScheduleDaysOptions {\n        label\n        value\n      }\n      schedule {\n        itsOpenNow: itsAvailableAt(websiteId: $websiteId)\n      }\n      currentPreparationDuration\n      currentDeliveryDuration\n      availablePaymentTypes\n    }\n  }\n"
    ]);
    scheduleFragment_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var scheduleFragment_main = ((0,lib["default"])(scheduleFragment_main_templateObject()));

// EXTERNAL MODULE: ./src/data/fragments/checkout/v3/summaryFragment.main.ts
var summaryFragment_main = __webpack_require__(2677);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/v3/v3.main.ts
function v3_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function v3_main_templateObject() {
    var data = v3_main_taggedTemplateLiteral([
        "\n  fragment checkoutV3Preferences on Preference {\n    _id\n    websiteId\n    storeId\n    ...checkoutV3ProfilePreferences\n    ...checkoutV3CartPreferences\n    ...checkoutV3SchedulePreferences\n    ...checkoutV3DeliveryPreferences\n    ...checkoutV3PickupPreferences\n    ...checkoutV3SummaryPreferences\n    ...checkoutV3CouponPreferences\n    ...checkoutV3PaymentMethodPreferences\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    v3_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









/**
 * Fetches the base information for rendering the Checkout V3.
 * Note: Only add fields that are required for the first render.
 * If you need to fetch info displayed for example when opening a modal, use a separate query.
 */ /* harmony default export */ var v3_main = ((0,lib["default"])(v3_main_templateObject(), profileFragment_main, cartFragment_main/* default */.Z, scheduleFragment_main, deliveryFragment_main, pickupFragment_main, summaryFragment_main/* default */.Z, couponFragment_main/* default */.Z, paymentMethodFragment_main/* default */.Z));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/v3/index.ts

/* harmony default export */ var v3 = (v3_main);


/***/ }),

/***/ 39489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment checkoutV3PaymentMethodPreferences on Preference {\n    _id\n    paymentType\n    cardId\n    otherPaymentType\n    website {\n      _id\n      stores {\n        _id\n      }\n    }\n    card {\n      _id\n      brandId\n      brandName\n      last4\n      cardType\n    }\n    websiteCoinsToSpend\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject()));


/***/ }),

/***/ 2677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment checkoutV3SummaryPreferences on Preference {\n    tipAmount\n    tipPercentage\n\n    deliveryType\n\n    address {\n      _id\n    }\n\n    store {\n      _id\n      hideTip\n    }\n\n    website {\n      _id\n      noTipByDefault\n      bagCost\n    }\n\n    loyaltyProgram\n\n    cart {\n      pointsDetails {\n        amount\n        name\n      }\n      deliveryFee\n      itemsPrice\n      subtotalWithProductDiscount: itemsPrice(\n        includeDiscount: true\n        includeCoupon: false\n        includeJustoCoins: false\n        includeLoyaltyDiscount: false\n        includeWebsiteCoins: false\n      )\n\n      priceBeforeWebsiteCoins: itemsPrice(\n        includeDiscount: true\n        includeCoupon: true\n        includeJustoCoins: false\n        includeWebsiteCoins: false\n      )\n      amountToPay\n      totalPrice\n      realPrice: itemsPrice(includeDiscount: false)\n      acceptsTip\n      hasFixedAmountTips\n      tipOptions\n      tipPercentagesOptions\n      calculatedTipAmount\n\n      couponStatus {\n        code\n        name\n        discount\n      }\n\n      specialRequirementsIds\n\n      loyaltyTransactionStatus {\n        transactionId\n        loyaltyName\n        discount\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject()));


/***/ }),

/***/ 63879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useMyOrderPreferencesSlim; }
/* harmony export */ });
/* unused harmony export getMyOrderPreferencesSlimQuery */
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getMyOrderPreferencesSlim($websiteId: ID) {\n    preferences: userPreferences(websiteId: $websiteId) {\n      _id\n      menuId\n      storeId\n      deliverAt\n      deliveryType\n      tableName\n      time\n      shouldHidePrice\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




// IMPORTANT: Do not add fields here. This query is optimized and should not be modified.
var getMyOrderPreferencesSlimQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject());
var useMyOrderPreferencesSlim = function(websiteId) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        partial: true
    };
    var savedWebsiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    websiteId = websiteId !== null && websiteId !== void 0 ? websiteId : savedWebsiteId;
    return (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useApolloQuery */ .Zu)({
        query: getMyOrderPreferencesSlimQuery,
        variables: {
            websiteId: websiteId
        },
        omit: (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)() || !websiteId,
        fetchPolicy: "cache-first",
        partial: opts.partial
    });
};


/***/ }),

/***/ 89894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((classnames__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ 62280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getQueryObject; }
/* harmony export */ });
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17673);

function getQueryObject(router) {
    var ref;
    var queryString = (ref = router.asPath.split("?")[1]) !== null && ref !== void 0 ? ref : "";
    return (0,querystring__WEBPACK_IMPORTED_MODULE_0__.parse)(queryString);
};


/***/ }),

/***/ 1003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useDebounce; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/helpers/misc/createFastHash.ts
/**
 * https://github.com/bevacqua/hash-sum/blob/master/hash-sum.js
 */ 
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function pad(hash, len) {
    while(hash.length < len){
        hash = "0" + hash;
    }
    return hash;
}
function fold(hash, text) {
    var i;
    var chr;
    var len;
    if (text.length === 0) {
        return hash;
    }
    for(i = 0, len = text.length; i < len; i++){
        chr = text.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash < 0 ? hash * -2 : hash;
}
function foldObject(hash1, o, seen) {
    var foldKey = function foldKey(hash, key) {
        return foldValue(hash, o[key], key, seen);
    };
    return Object.keys(o).sort().reduce(foldKey, hash1);
}
function foldValue(input, value, key, seen) {
    var hash = fold(fold(fold(input, key), createFastHash_toString(value)), typeof value === "undefined" ? "undefined" : _typeof(value));
    if (value === null) {
        return fold(hash, "null");
    }
    if (value === undefined) {
        return fold(hash, "undefined");
    }
    if (typeof value === "object" || typeof value === "function") {
        if (seen.indexOf(value) !== -1) {
            return fold(hash, "[Circular]" + key);
        }
        seen.push(value);
        var objHash = foldObject(hash, value, seen);
        if (!("valueOf" in value) || typeof value.valueOf !== "function") {
            return objHash;
        }
        try {
            return fold(objHash, String(value.valueOf()));
        } catch (err) {
            return fold(objHash, "[valueOf exception]" + (err.stack || err.message));
        }
    }
    return fold(hash, value.toString());
}
function createFastHash_toString(o) {
    return Object.prototype.toString.call(o);
}
function sum(o) {
    return pad(foldValue(0, o, "", []).toString(16), 8);
}
/* harmony default export */ var createFastHash = (sum);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
;// CONCATENATED MODULE: ./src/hooks/useDebounce.ts



function useDebounce(value, wait) {
    var ref = (0,react.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    var hashed = createFastHash(value);
    (0,react.useEffect)(function() {
        var tid = setTimeout(function() {
            return setDebouncedValue(value);
        }, wait);
        return function() {
            return clearTimeout(tid);
        };
    }, [
        hashed
    ]);
    var loading = !isEqual_default()(value, debouncedValue);
    return [
        debouncedValue,
        loading
    ];
};


/***/ }),

/***/ 68400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsStore; }
});

;// CONCATENATED MODULE: ./src/helpers/websites/isStore.ts
function isStore(businessType) {
    return businessType === "store";
};

// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
;// CONCATENATED MODULE: ./src/hooks/useWebsiteBusinessType.ts

function useWebsiteBusinessType() {
    var website = (0,useInitialData/* default */.Z)().website;
    return website.businessType;
};

;// CONCATENATED MODULE: ./src/hooks/useIsStore.ts


function useIsStore(website) {
    var businessType = useWebsiteBusinessType();
    if (website === null || website === void 0 ? void 0 : website.businessType) {
        businessType = website.businessType;
    }
    return isStore(businessType);
};


/***/ }),

/***/ 1626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyboardEvent(combination, callback) {
    var keysToMatch = combination.toLowerCase().split("+");
    var keys = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    callbackRef.current = callback;
    var checkEvent = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysToMatch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var keyToMatch = _step.value;
                if (!keys[keyToMatch]) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callbackRef.current();
    };
    var onKeyDown = function(event) {
        if (event && event.key) {
            var key = event.key.toLowerCase();
            keys[key] = true;
        }
    };
    var onKeyUp = function(event) {
        if (event && event.key) {
            checkEvent();
            var key = event.key.toLowerCase();
            delete keys[key];
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keyup", onKeyUp);
        document.addEventListener("keydown", onKeyDown);
        return function() {
            document.removeEventListener("keyup", onKeyUp);
            document.removeEventListener("keydown", onKeyDown);
        };
    });
};


/***/ }),

/***/ 5528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMessage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_contexts_ShowMessageContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59325);


function useMessage() {
    var showMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_packages_justo_parts_lib_contexts_ShowMessageContext__WEBPACK_IMPORTED_MODULE_1__["default"]);
    return showMessage;
};


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 47592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSharedPageRewriteHelper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62280);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



/**
 * When using a shared page for different routes (e.g. /order and /order/productId/productName),
 * we need to force the param (productId) into the router query object.
 * Unfortunatelly, when doing a rewrite in the middleware, the passed query vars are not available.
 * @param resourceKey the key to force onto the router (e.g. 'productId')
 * @param getResourceFromUrlFn a fn that parses the current path and returns the resource value (e.g. getProductIdFromUrl)
 * @returns the router
 */ function useSharedPageRewriteHelper(resourceKey, getResourceFromUrlFn) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // We use useEffect so that the cached SSR version does not render the resource. It should render the wrapper instead.
        var matchedResource = getResourceFromUrlFn(router.asPath);
        if (router.isReady && matchedResource && router.query[resourceKey] !== matchedResource) {
            var query = (0,_helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(router);
            router.replace({
                pathname: window.location.pathname,
                query: _objectSpread({}, query, _defineProperty({}, resourceKey, matchedResource))
            });
        }
    }, [
        router,
        resourceKey,
        getResourceFromUrlFn
    ]);
    return router;
};


/***/ }),

/***/ 57846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getQueryParam; }
/* harmony export */ });
function getQueryParam(param) {
    var query = param.query, key = param.key;
    var value = query[key];
    if (!value) return;
    return value;
};


/***/ }),

/***/ 64105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useURLState; }
});

// EXTERNAL MODULE: ./node_modules/lodash/isNull.js
var isNull = __webpack_require__(45220);
var isNull_default = /*#__PURE__*/__webpack_require__.n(isNull);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useURLState/getQueryParam.ts
var getQueryParam = __webpack_require__(57846);
// EXTERNAL MODULE: ./src/helpers/misc/getQueryObject.ts
var getQueryObject = __webpack_require__(62280);
;// CONCATENATED MODULE: ./src/hooks/useURLState/setQueryParam.ts


function setQueryParam(param) {
    var key = param.key, value = param.value, router = param.router, replaceHistory = param.replaceHistory;
    var searchParams = (0,getQueryObject/* default */.Z)(router);
    if (isNull_default()(value)) {
        delete searchParams[key];
    } else {
        searchParams[key] = value;
    }
    if (replaceHistory) {
        var ref;
        router.push({
            pathname: window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname,
            query: searchParams
        });
    }
};

;// CONCATENATED MODULE: ./src/hooks/useURLState/index.ts




function useURLState(key) {
    var initialValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, replaceHistory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var router = (0,next_router.useRouter)();
    var queryParam = (0,getQueryParam/* default */.Z)({
        query: router.query,
        key: key
    }) || initialValue;
    var onChange = function(newValue) {
        if (isNull_default()(newValue)) {
            setQueryParam({
                key: key,
                value: null,
                replaceHistory: replaceHistory,
                router: router
            });
        } else {
            setQueryParam({
                key: key,
                value: newValue,
                replaceHistory: replaceHistory,
                router: router
            });
        }
    };
    return [
        queryParam,
        onChange
    ];
};


/***/ }),

/***/ 70487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePreferences; }
/* harmony export */ });
/* harmony import */ var _data_fragments_checkout_v3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14204);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getCheckoutV3($websiteId: ID) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          ...checkoutV3Preferences\n        }\n      }\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function usePreferences() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var result = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__["default"])(_templateObject(), _data_fragments_checkout_v3__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first",
        pollInterval: 1000 * 60 * 10,
        omit: (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)()
    });
    return {
        preferences: result.preferences,
        loading: result.loading
    };
};


/***/ }),

/***/ 23023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Example; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5434);
/* harmony import */ var _components_V3_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1555);



function Example() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "min-h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto max-w-max",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                    className: "sm:flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-4xl font-bold tracking-tight text-indigo-600 sm:text-5xl",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_2__/* .MdWifiOff */ .Em6, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "sm:ml-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "sm:border-l sm:border-gray-200 sm:pl-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                                            children: "Este sitio esta desactivado"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-1 text-base text-gray-500",
                                            children: "Para activarlo, contacta a cobranzas@getjusto.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_V3_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        primary: true,
                                        onClick: function() {
                                            return window.location.href = "https://getjusto.com";
                                        },
                                        children: "Ir a Justo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 25442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NoWebsite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43469);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function NoWebsite(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/no-website.svg",
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().image)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Este sitio web no est\xe1 configurado correctamente"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://getjusto.com",
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().logo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/logo-dark.svg"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 31669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePreferencesForResume; }
/* harmony export */ });
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getPreferencesForResume($websiteId: ID!) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          sessionEmail\n          sessionEmailHasName\n          deliveryType\n          menuId\n          store {\n            _id\n            currentExtraDeliveryCost\n          }\n\n          address {\n            _id\n          }\n\n          bagsRequired\n\n          cart {\n            deliveryFee\n            itemsPrice\n            realPrice: itemsPrice(includeDiscount: false)\n            subtotal: itemsPrice(\n              includeDiscount: true\n              includeCoupon: true\n              includeJustoCoins: false\n              includeLoyaltyDiscount: false\n              includeWebsiteCoins: false\n            )\n            couponStatus {\n              discount\n            }\n            totalPrice\n            bagAmount\n            calculatedBagsRequired\n            maxBagsAllowed\n            items {\n              _id\n              isOutOfStock\n              productId\n              product {\n                _id\n                name\n              }\n              amount\n            }\n            deliveryType\n            storeId\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function usePreferencesForResume() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var preferences = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-and-network"
    }).preferences;
    return preferences;
};


/***/ }),

/***/ 98769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCartDetails; }
/* harmony export */ });
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        '\n      query getCartDetails($websiteId: ID!) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          cart {\n            items {\n              _id\n              description\n              descriptionItems {\n                title\n                selections\n              }\n\n              modifiers {\n                modifierId\n                optionsIds\n              }\n              unitPrice\n              realPrice: unitPrice(includeDiscount: false)\n              amount\n              outOfStockMessage\n              isOutOfStock\n\n              product {\n                _id\n                name\n                image {\n                  _id\n                  url: resizedURL(width: 60, height: 60, format: "webp")\n                }\n              }\n            }\n          }\n        }\n      }\n    '
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useCartDetails() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var preferences = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }).preferences;
    return preferences.cart;
};


/***/ }),

/***/ 33298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWhatsAppCommerceNumber; }
/* harmony export */ });
/* harmony import */ var _hooks_useIsSpecialLayout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5455);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getWhatsAppCommerceNumber($websiteId: ID) {\n        website(websiteId: $websiteId) {\n          _id\n          whatsappChatCommerceNumber\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function useWhatsAppCommerceNumber() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var isSpecialLayout = (0,_hooks_useIsSpecialLayout__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var website = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: isSpecialLayout !== "chat"
    }).website;
    return website ? website.whatsappChatCommerceNumber : null;
};


/***/ }),

/***/ 66508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCartPreferences; }
/* harmony export */ });
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getCartPreferences($websiteId: ID!) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          menuId\n          tableName\n          deliveryType\n          storeId\n          cart {\n            itemsPrice\n            totalPrice\n            realPrice: itemsPrice(includeDiscount: false)\n            subtotal: itemsPrice(\n              includeDiscount: true\n              includeCoupon: true\n              includeJustoCoins: false\n              includeLoyaltyDiscount: false\n              includeWebsiteCoins: false\n            )\n            items {\n              _id\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useCartPreferences() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var preferences = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-and-network"
    }).preferences;
    return preferences;
};


/***/ }),

/***/ 3306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OptionsLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5434);
/* harmony import */ var _components_DeliveryWizard_internals_hooks_useIsOutOfBounds__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58513);
/* harmony import */ var _components_DeliveryWizard_internals_hooks_usePreferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38417);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89894);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32533);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64321);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);








function OptionsLabel() {
    var ref = (0,_components_DeliveryWizard_internals_hooks_usePreferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), preferences = ref.preferences, loading = ref.loading;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("website", {
        keyPrefix: "order.cartMenuV2.optionsLabel"
    }).t;
    var outOfBounds = (0,_components_DeliveryWizard_internals_hooks_useIsOutOfBounds__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (!preferences || loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().loading)
    });
    if (outOfBounds) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container), "flex items-center"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_7__/* .MdOutlineWarning */ .hid, {
                className: "w-5 h-5 mr-2 text-orange-200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: t("outOfBounds")
            })
        ]
    });
    if (preferences.deliveryType === "delivery") {
        if (preferences.address) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
                children: preferences.address.address
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
                children: t("address")
            });
        }
    }
    if (!preferences.store) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
            children: t("store")
        });
    }
    if (preferences.deliveryType === "go") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
            children: t("storeGo", {
                store: preferences.store.name
            })
        });
    }
    var label = preferences.tableName ? t("labelTable", {
        table: preferences.tableName
    }) : t("labelServe");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: [
            preferences.store.name,
            ", ",
            label
        ]
    });
};


/***/ }),

/***/ 47731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_queries_website_websiteMenuInformation_main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41372);

function useCartV3() {
    var website = (0,_data_queries_website_websiteMenuInformation_main__WEBPACK_IMPORTED_MODULE_0__/* .useWebsiteMenuInformation */ .g9)().website;
    return website.businessType === "restaurant";
}
/* harmony default export */ __webpack_exports__["Z"] = (useCartV3);


/***/ }),

/***/ 31295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useAddressLabel; },
/* harmony export */   "Z": function() { return /* binding */ AddressLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_DeliveryWizard_internals_hooks_useIsOutOfBounds__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58513);
/* harmony import */ var _components_SafeSuspense__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5822);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50456);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32533);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query addressLabelPreferences($websiteId: ID!) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          deliveryType\n          tableName\n          store {\n            _id\n            name\n          }\n          address {\n            _id\n            address\n            addressLine2\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function useAddressLabel() {
    var ref, ref1;
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var preferences = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_8__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }).preferences;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("website", {
        keyPrefix: "delivery.address"
    }).t;
    var isOutOfBounds = (0,_components_DeliveryWizard_internals_hooks_useIsOutOfBounds__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (isOutOfBounds) {
        return t("outOfBounds");
    }
    if ((preferences === null || preferences === void 0 ? void 0 : preferences.deliveryType) === "serve" && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(preferences === null || preferences === void 0 ? void 0 : preferences.tableName)) {
        var ref2;
        return t("serve", {
            tableName: preferences.tableName,
            storeName: (ref2 = preferences.store) === null || ref2 === void 0 ? void 0 : ref2.name
        });
    }
    if ((preferences === null || preferences === void 0 ? void 0 : preferences.deliveryType) === "go" && (preferences === null || preferences === void 0 ? void 0 : (ref = preferences.store) === null || ref === void 0 ? void 0 : ref.name)) {
        return t("go", {
            storeName: preferences.store.name
        });
    }
    if ((preferences === null || preferences === void 0 ? void 0 : preferences.deliveryType) === "delivery" && (preferences === null || preferences === void 0 ? void 0 : (ref1 = preferences.address) === null || ref1 === void 0 ? void 0 : ref1.address)) {
        var ref3;
        var address = (((ref3 = preferences.address) === null || ref3 === void 0 ? void 0 : ref3.addressLine2) ? preferences.address.addressLine2 + ", " : "") + preferences.address.address;
        return t("delivery", {
            address: address
        });
    }
    return t("empty");
}
function AddressLabelInner() {
    var label = useAddressLabel();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "whitespace-nowrap text-ellipsis overflow-hidden",
        children: label
    });
}
function AddressLabel() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SafeSuspense__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        fallback: null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddressLabelInner, {})
    });
};


/***/ }),

/***/ 39268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TimeLabel; },
/* harmony export */   "z": function() { return /* binding */ useTimeLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SafeSuspense__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5822);
/* harmony import */ var _data_queries_preferences_getMyOrderPreferencesSlim_main__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63879);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50456);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32533);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query timeLabelPrefs($websiteId: ID) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          timeLabel\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function useTimeLabel() {
    var ref, ref1;
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var data = (0,_data_queries_preferences_getMyOrderPreferencesSlim_main__WEBPACK_IMPORTED_MODULE_3__/* .useMyOrderPreferencesSlim */ .b)(websiteId, {
        partial: false
    });
    var preferences = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_7__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: (data === null || data === void 0 ? void 0 : (ref = data.preferences) === null || ref === void 0 ? void 0 : ref.time) === "now",
        fetchPolicy: "cache-first"
    }).preferences;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("website", {
        keyPrefix: "schedule"
    }).t;
    if ((data === null || data === void 0 ? void 0 : (ref1 = data.preferences) === null || ref1 === void 0 ? void 0 : ref1.time) === "now") {
        return t("asSoonAsPossible");
    }
    return preferences === null || preferences === void 0 ? void 0 : preferences.timeLabel;
}
function TimeLabelInner() {
    var label = useTimeLabel();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "whitespace-nowrap text-ellipsis overflow-hidden",
        children: label
    });
}
function TimeLabel() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SafeSuspense__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        fallback: null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimeLabelInner, {})
    });
};


/***/ }),

/***/ 19544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DeliveryHeaderMobile; }
/* harmony export */ });
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_app_events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5275);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89583);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5434);
/* harmony import */ var _components_DeliveryWizard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16312);
/* harmony import */ var _components_DeliveryWizard_internals_hooks_useIsOutOfBounds__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58513);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89894);
/* harmony import */ var _hooks_useMessage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5528);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32533);
/* harmony import */ var _AddressLabel_main__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31295);
/* harmony import */ var _TimeLabel_main__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39268);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}













function DeliveryHeaderMobile() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref[0], setOpen = ref[1];
    var isOutOfBounds = (0,_components_DeliveryWizard_internals_hooks_useIsOutOfBounds__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var showMessage = (0,_hooks_useMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$G)("website", {
        keyPrefix: "delivery"
    }).t;
    (0,react_app_events__WEBPACK_IMPORTED_MODULE_3__/* .useOnEvent */ .dh)("hiddenPriceProductOpened", _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    showMessage(t("hiddenPriceWarning"));
                    setOpen(true);
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("p-4 mt-4 flex justify-between items-center w-full text-white primaryBackgroundColor primaryBorderColor border-1 font-semibold cursor-pointer", {
                }),
                onClick: function() {
                    return setOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex flex-1 items-center gap-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "items-center flex",
                                children: isOutOfBounds ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_11__/* .MdWarningAmber */ .ESo, {
                                    className: "text-orange-200 h-5 w-5 inline-block mr-1"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_11__/* .MdLocationPin */ .vcr, {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AddressLabel_main__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                        ]
                    }),
                    isOutOfBounds ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "flex flex-1 items-center justify-end gap-1 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "items-center flex",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaRegClock */ .fSQ, {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_TimeLabel_main__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_DeliveryWizard__WEBPACK_IMPORTED_MODULE_4__/* ["default"].AsModal */ .Z.AsModal, {
                actionLocation: "order-delivery",
                isOpen: open,
                onClose: function() {
                    return setOpen(false);
                }
            })
        ]
    });
};


/***/ }),

/***/ 31143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);



function LoadingProducts(param) {
    var fullScreen = param.fullScreen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            "col-xs-12 col-sm-6 col-md-8": !fullScreen,
            "col-xs-12": fullScreen
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col animate-pulse",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "my-9 h-14 w-full bg-gray-300 dark:bg-gray-600 rounded"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-1 mb-3 h-12 w-40 bg-gray-300 dark:bg-gray-600 rounded"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-1 h-6 w-24 bg-gray-300 dark:bg-gray-600 rounded"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative rounded-xl overflow-auto p-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row space-x-4",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-row space-x-4 mt-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-1 mb-5 h-6 w-24 bg-gray-300 dark:bg-gray-600 rounded"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative rounded-xl overflow-auto p-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row space-x-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "basis-full md:basis-1/2 h-[152px] flex items-center justify-center bg-gray-300 dark:bg-gray-600 rounded"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 66218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductsLayout; }
/* harmony export */ });
function useProductsLayout(website) {
    if (!website) return "long";
    return website.productsLayout || "long";
};


/***/ }),

/***/ 64497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ OrderPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/SsgFallback/index.tsx
var SsgFallback = __webpack_require__(19060);
// EXTERNAL MODULE: ./src/data/queries/website/websiteMenuInformation.main.tsx + 1 modules
var websiteMenuInformation_main = __webpack_require__(41372);
// EXTERNAL MODULE: ./node_modules/next/server.js
var server = __webpack_require__(97385);
;// CONCATENATED MODULE: ./src/helpers/middleware/sharedPages/product.ts


var getProductIdFromOrderUrl = function(pathname) {
    var match = pathname.match(/^\/(order|pedir)\/([^\/\?]+)\/?([^\/]*)/);
    if (!match) return null;
    if (match[2] === "category") return null;
    return match[2];
};
var rewriteProduct = function(url, pathname, mobileOrDesktop, hostname) {
    var productId = getProductIdFromOrderUrl(pathname);
    if (productId) {
        url.pathname = "".concat(getTenantPath(mobileOrDesktop, hostname), "/order");
        url.searchParams.set("productId", productId);
        return NextResponse.rewrite(url);
    }
    return null;
};

// EXTERNAL MODULE: ./src/hooks/useSharedPageRewriteHelper.ts
var useSharedPageRewriteHelper = __webpack_require__(47592);
// EXTERNAL MODULE: ./src/page-components/DeactivatedByDebt/index.tsx
var DeactivatedByDebt = __webpack_require__(23023);
// EXTERNAL MODULE: ./src/page-components/Layout/AbstractLayout.tsx + 30 modules
var AbstractLayout = __webpack_require__(50801);
// EXTERNAL MODULE: ./src/page-components/Layout/Website/index.tsx + 18 modules
var Website = __webpack_require__(20151);
// EXTERNAL MODULE: ./src/page-components/NoWebsite/index.tsx
var NoWebsite = __webpack_require__(25442);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/Loading.tsx
var Loading = __webpack_require__(53762);
// EXTERNAL MODULE: ./src/data/queries/preferences/getMyOrderPreferencesSlim.main.ts
var getMyOrderPreferencesSlim_main = __webpack_require__(63879);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/helpers/websites/doesCountryRequireCookies.ts
var doesCountryRequireCookies = __webpack_require__(2840);
// EXTERNAL MODULE: ./src/hooks/useCountryCode.ts
var useCountryCode = __webpack_require__(50900);
// EXTERNAL MODULE: ./src/hooks/useEventsBaseProperties.ts
var useEventsBaseProperties = __webpack_require__(87037);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
;// CONCATENATED MODULE: ./src/hooks/useWebsiteAddressInstructionModal.main.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getPreferencesForAddressInstructions($websiteId: ID) {\n        website(websiteId: $websiteId) {\n          _id\n          shouldUseInitialAddressMode\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useWebsiteAddressInstructionModal() {
    var ref;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var data = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first",
        omit: !websiteId
    }).data;
    return !!(data === null || data === void 0 ? void 0 : (ref = data.website) === null || ref === void 0 ? void 0 : ref.shouldUseInitialAddressMode);
};

// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/page-components/Order/CartV3/hooks/useCartV3.tsx
var useCartV3 = __webpack_require__(47731);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Loading/index.tsx
var ProductsContent_Loading = __webpack_require__(31143);
// EXTERNAL MODULE: ./src/page-components/Order/CartLoadingContext.tsx
var CartLoadingContext = __webpack_require__(10177);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/hooks/useCart.main.tsx
var useCart_main = __webpack_require__(66508);
// EXTERNAL MODULE: ./src/hooks/useIsSpecialLayout.ts
var useIsSpecialLayout = __webpack_require__(5455);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Resume/hooks/usePreferencesForResume.main.ts
var usePreferencesForResume_main = __webpack_require__(31669);
// EXTERNAL MODULE: ./src/components/V3/Button/index.tsx
var Button = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 1 modules
var formatNumber = __webpack_require__(78263);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartButton/AmountToReachButton.tsx




function AmountToReachButton(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var i18nWebsite = "website:order.cart.content.resume";
    var amountToReach = props.amountToReach;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-center m-2 mb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                primary: true,
                disabled: true,
                children: t("".concat(i18nWebsite, ".labelNotReachedMin"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "description",
                style: {
                    marginTop: 5
                },
                children: t("".concat(i18nWebsite, ".labelAddMoreProducts"), {
                    money: (0,formatNumber/* default */.Z)(amountToReach, "money")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/useWhatsAppCommerceNumber.ts
var useWhatsAppCommerceNumber = __webpack_require__(33298);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartButton/ChatButton.tsx





function ChatButton(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var i18nWebsite = "website:order.cart.content.resume";
    var redirecting = props.redirecting, setRedirecting = props.setRedirecting;
    var whatsappChatCommerceNumber = (0,useWhatsAppCommerceNumber/* default */.Z)();
    var goToWhatsapp = function() {
        setRedirecting(true);
        if (!whatsappChatCommerceNumber) {
            var justoBotPhoneNumber = "18453032928" // TODO: CRUD and fetch from backend
            ;
            router.push("/whatsapp-redirect?phone=".concat(justoBotPhoneNumber, "&text=Completar"));
            return;
        }
        router.push("/whatsapp-redirect?phone=".concat(whatsappChatCommerceNumber.replace("+", ""), "&text=Completar"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center m-2 mb-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            primary: true,
            onClick: goToWhatsapp,
            loading: redirecting,
            children: t("".concat(i18nWebsite, ".labelCompleteOrderInWhatsapp"))
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/warningBox.tsx
var warningBox = __webpack_require__(1829);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartButton/ContinueButton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








function ContinueButton(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var redirecting = props.redirecting, preferences = props.preferences, setRedirecting = props.setRedirecting;
    var i18nProduct = "order.products.productsContent.selectProduct";
    var i18nGeneric = "generic:fields";
    var checkoutPath = "/checkout";
    var baseEventProperties = (0,useEventsBaseProperties/* default */.Z)();
    var goToReview = function() {
        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.continueToCheckout */.F.purchase.continueToCheckout, _objectSpread({}, baseEventProperties));
        setRedirecting(true);
        router.push(checkoutPath);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-center mx-2 justify-center",
        children: [
            !(preferences === null || preferences === void 0 ? void 0 : preferences.store) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex justify-center mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(warningBox/* default */.Z, {
                    children: t("".concat(i18nProduct, ".inner.actions.labelAddAddressOrSelectStore"))
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "h-12 text-base",
                primary: true,
                full: true,
                onClick: goToReview,
                loading: redirecting,
                disabled: !(preferences === null || preferences === void 0 ? void 0 : preferences.store),
                children: t("".concat(i18nGeneric, ".continue"))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/hooks/useCartModalContext.ts

var CartModalContext = react.createContext({});
/* harmony default export */ var useCartModalContext = (CartModalContext);

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartButton/GoToMenuButton.tsx





function GoToMenuButton() {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cart.content.resume"
    }).t;
    var cartModalContext = (0,react.useContext)(useCartModalContext);
    if (!cartModalContext.closeModal) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center m-2 mb-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-center mx-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "h-12 text-base",
                onClick: cartModalContext.closeModal,
                primary: true,
                full: true,
                children: t("labelGoToMenu")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartButton/OutOfStockButton.tsx



function OutOfStockButton() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var i18nWebsite = "website:order.cart.content.resume";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center m-4 mb-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            primary: true,
            disabled: true,
            children: t("".concat(i18nWebsite, ".labelProductsOutStock"))
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartButton/Skeleton.tsx



function CartButtonSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center mx-2 justify-center animate-pulse",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: "h-12 text-base",
            primary: true,
            full: true,
            disabled: true,
            children: "Cargando..."
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartButton/index.tsx











function InnerCartButton() {
    var ref, ref1;
    var website = (0,useInitialData/* default */.Z)().website;
    var preferences = (0,usePreferencesForResume_main/* default */.Z)();
    var isSpecialLayout = (0,useIsSpecialLayout/* default */.Z)();
    var ref2 = (0,react.useState)(false), redirecting = ref2[0], setRedirecting = ref2[1];
    var itemsPrice = preferences === null || preferences === void 0 ? void 0 : (ref = preferences.cart) === null || ref === void 0 ? void 0 : ref.itemsPrice;
    var items = preferences === null || preferences === void 0 ? void 0 : (ref1 = preferences.cart) === null || ref1 === void 0 ? void 0 : ref1.items;
    var amountToReachMinimum = function() {
        if (!(website === null || website === void 0 ? void 0 : website.minimumOrderPrice) || !itemsPrice) return 0;
        var amount = website.minimumOrderPrice - itemsPrice;
        if (amount > 0) return amount;
        return 0;
    };
    var hasAnyOutOfStock = items === null || items === void 0 ? void 0 : items.find(function(item) {
        return item === null || item === void 0 ? void 0 : item.isOutOfStock;
    });
    if (hasAnyOutOfStock) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockButton, {});
    var amountToReach = amountToReachMinimum();
    if (amountToReach) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AmountToReachButton, {
            amountToReach: amountToReach
        });
    }
    if (isSpecialLayout === "chat") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatButton, {
        redirecting: redirecting,
        setRedirecting: setRedirecting
    });
    if (!(items === null || items === void 0 ? void 0 : items.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoToMenuButton, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContinueButton, {
        redirecting: redirecting,
        setRedirecting: setRedirecting,
        preferences: preferences
    });
}
function CartButton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButtonSkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCartButton, {})
    });
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/index.js
var react_app_events_lib = __webpack_require__(5275);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/index.tsx + 1 modules
var DeliveryWizard = __webpack_require__(16312);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useIsOutOfBounds.ts
var useIsOutOfBounds = __webpack_require__(58513);
// EXTERNAL MODULE: ./src/page-components/Order/DeliveryHeaderMobile/AddressLabel.main.tsx
var AddressLabel_main = __webpack_require__(31295);
// EXTERNAL MODULE: ./src/page-components/Order/DeliveryHeaderMobile/TimeLabel.main.tsx
var TimeLabel_main = __webpack_require__(39268);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartDelivery/AddressAndTimeLabel.tsx







function AddressLabelInner() {
    var label = (0,AddressLabel_main/* useAddressLabel */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "text-xs font-semibold",
        children: label
    });
}
function TimeLabelInner() {
    var label = (0,TimeLabel_main/* useTimeLabel */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "flex text-xs font-normal italic",
        children: label
    });
}
function DeliveryTypeIcon(param) {
    var deliveryType = param.deliveryType;
    switch(deliveryType){
        case "go":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineShoppingBag */.t5$, {
                className: "h-6 w-6"
            });
        case "serve":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdRestaurant */.TkG, {
                className: "h-6 w-6"
            });
        case "delivery":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaMotorcycle */.VJF, {
                className: "h-6 w-6"
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdLocationOn */.$0r, {
                className: "h-6 w-6"
            });
    }
}
function AddressAndTimeLabel() {
    var isOutOfBounds = (0,useIsOutOfBounds/* default */.Z)();
    var preferences = (0,useCart_main/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-2 px-2 truncate",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center",
                children: isOutOfBounds ? /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdWarningAmber */.ESo, {
                    className: "text-orange-200 h-5 w-5 inline-block mr-1"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryTypeIcon, {
                    deliveryType: preferences.deliveryType
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressLabelInner, {}),
                    isOutOfBounds ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeLabelInner, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartDelivery/Skeleton.tsx

function CartDeliverySkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-2 py-2 h-12 animate-pulse flex items-center text-sm cursor-pointer bg-gray-100 dark:bg-gray-500 rounded-full"
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartDelivery/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









function InnerCartDelivery() {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "delivery"
    }).t;
    var showMessage = (0,useMessage/* default */.Z)();
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    (0,react_app_events_lib/* useOnEvent */.dh)("hiddenPriceProductOpened", _asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    showMessage(t("hiddenPriceWarning"));
                    setOpen(true);
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-2 py-2 flex items-center text-sm cursor-pointer bg-gray-100 dark:bg-gray-500 rounded-full",
                onClick: function() {
                    return setOpen(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressAndTimeLabel, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryWizard/* default.AsModal */.Z.AsModal, {
                actionLocation: "order-delivery",
                isOpen: open,
                onClose: function() {
                    return setOpen(false);
                }
            })
        ]
    });
}
function CartDelivery() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDeliverySkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCartDelivery, {})
    });
};

// EXTERNAL MODULE: ./src/helpers/misc/classnames.ts
var classnames = __webpack_require__(89894);
// EXTERNAL MODULE: ./src/hooks/useIsDarkMode.ts
var useIsDarkMode = __webpack_require__(54731);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/hooks/useCartDetails.main.ts
var useCartDetails_main = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/components/V3/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(12652);
// EXTERNAL MODULE: ./src/page-components/CheckoutV3/hooks/usePreferences.main.ts
var usePreferences_main = __webpack_require__(70487);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/index.tsx
var SuspenseLoading = __webpack_require__(75288);
// EXTERNAL MODULE: ./src/components/V3/Pill/index.tsx
var Pill = __webpack_require__(94279);
// EXTERNAL MODULE: ./src/hooks/useAnalyticLocation.ts
var useAnalyticLocation = __webpack_require__(78425);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts + 1 modules
var useDebounce = __webpack_require__(1003);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Item/ItemContext.tsx

/* harmony default export */ var ItemContext = (/*#__PURE__*/react.createContext(null));

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Item/QuantityButton.tsx




function QuantityButton(param) {
    var children = param.children, onClick = param.onClick;
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: onClick,
        className: (0,classnames/* default */.Z)({
            "text-sm font-semibold w-8 h-8 rounded-full items-center justify-center": true,
            border: true,
            "border-gray-200": !isDarkMode,
            "border-gray-400": isDarkMode,
            "bg-gray-100": !isDarkMode,
            "bg-gray-600": isDarkMode,
            "transition ease-in-out duration-150": true,
            "hover:bg-gray-200": !isDarkMode,
            "hover:bg-gray-400": isDarkMode
        }),
        children: children
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/index.tsx + 36 modules
var SelectProduct = __webpack_require__(1683);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Item/Actions/EditProduct.tsx
function EditProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function EditProduct_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                EditProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                EditProduct_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







function EditProduct(param) {
    var cartItemId = param.cartItemId, onClose = param.onClose, setLoading = param.setLoading, isOpen = param.isOpen;
    var refetch = (0,apollo_hooks_es/* useRefetchQueries */.S1)();
    var cart = (0,useCartDetails_main/* default */.Z)();
    var showMessage = (0,useMessage/* default */.Z)();
    var item = cart === null || cart === void 0 ? void 0 : cart.items.find(function(i) {
        return i._id === cartItemId;
    });
    if (!item) return;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProduct/* default */.Z, {
        product: item.product,
        open: isOpen,
        cartItem: item,
        onAdd: EditProduct_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return refetch([
                            "getCartDetails",
                            "getPreferencesForResume"
                        ]).catch(function() {
                            return showMessage(new Error("Ocurri\xf3 un error al editar el producto. Intente nuevamente."));
                        });
                    case 3:
                        setLoading(false);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        close: onClose
    });
};

// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Item/Actions/useAdjustQuantity.main.ts
function useAdjustQuantity_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useAdjustQuantity_main_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useAdjustQuantity_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useAdjustQuantity_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useAdjustQuantity_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function useAdjustQuantity_main_templateObject() {
    var data = useAdjustQuantity_main_taggedTemplateLiteral([
        "\n          mutation cartV3UpdateCartItemAmount($cartItemId: ID!, $amount: Float!) {\n            updateCartItemAmount(cartItemId: $cartItemId, amount: $amount) {\n              _id\n              amount\n            }\n          }\n        "
    ]);
    useAdjustQuantity_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function useAdjustQuantityCart(param) {
    var cartItemId = param.cartItemId, setLoading = param.setLoading;
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var showMessage = (0,useMessage/* default */.Z)();
    var submit = function() {
        var _ref = useAdjustQuantity_main_asyncToGenerator(runtime_default().mark(function _callee(amount) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (amount) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setLoading(true);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return mutate({
                            mutation: (0,lib["default"])(useAdjustQuantity_main_templateObject()),
                            variables: {
                                cartItemId: cartItemId,
                                amount: amount
                            },
                            refetchQueries: [
                                "getCartDetails",
                                "getPreferencesForResume",
                                "getCheckoutV3"
                            ]
                        });
                    case 6:
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](3);
                        showMessage("Lo sentimos, no se pudo actualizar el producto");
                        logger/* default.error */.Z.error("Error UpdateCartItemAmount cartv3", _ctx.t0);
                    case 12:
                        _ctx.prev = 12;
                        setLoading(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    8,
                    12,
                    15
                ]
            ]);
        }));
        return function submit(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    return submit;
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Item/Actions/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Actions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Actions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Actions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
















function Actions(param) {
    var onDelete = param.onDelete;
    var t = (0,esm/* useTranslation */.$G)("generic").t;
    var item = (0,react.useContext)(ItemContext);
    var ref6 = (0,react.useState)(false), isEditing = ref6[0], setIsEditing = ref6[1];
    var ref1 = (0,react.useState)(false), loadingEdit = ref1[0], setLoading = ref1[1];
    var updateQuantity = useAdjustQuantityCart({
        cartItemId: item._id,
        setLoading: setLoading
    });
    var actionLocation = (0,useAnalyticLocation/* default */.Z)("purchaseEdit");
    var ref2 = (0,react.useState)(item.amount), quantity = ref2[0], setQuantity = ref2[1];
    var ref3 = _slicedToArray((0,useDebounce/* default */.Z)(quantity, 500), 2), debouncedQuantity = ref3[0], isDebouncing = ref3[1];
    var eventBaseProperties = (0,useEventsBaseProperties/* default */.Z)();
    var preferences = (0,usePreferences_main/* default */.Z)().preferences;
    var loading = loadingEdit || isDebouncing;
    (0,react.useEffect)(function() {
        // This triggers the server-side update only after the debouncer has finished
        if (debouncedQuantity !== item.amount) {
            var ref;
            updateQuantity(debouncedQuantity);
            var ref4, ref5;
            (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.productEdited */.F.purchase.productEdited, Actions_objectSpread({
                productEditAction: (item === null || item === void 0 ? void 0 : item.amount) === 0 ? "delete" : "edit",
                productId: (ref4 = item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref._id) !== null && ref4 !== void 0 ? ref4 : "",
                productAmount: item === null || item === void 0 ? void 0 : item.amount,
                isAmountEdited: true,
                isOutOfStock: item === null || item === void 0 ? void 0 : item.isOutOfStock,
                menuId: (ref5 = preferences === null || preferences === void 0 ? void 0 : preferences.menuId) !== null && ref5 !== void 0 ? ref5 : "",
                actionLocation: actionLocation
            }, eventBaseProperties));
        }
    }, [
        debouncedQuantity
    ]);
    (0,react.useEffect)(function() {
        // If the item amount gets updated elsewhere, we need to update our local indicator
        if (item.amount !== quantity) {
            setQuantity(item.amount);
        }
    }, [
        item.amount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-1 justify-start items-center",
                children: [
                    quantity === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityButton, {
                        onClick: onDelete,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdDelete */.ZkW, {})
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityButton, {
                        onClick: function() {
                            return setQuantity(quantity - 1);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdRemove */.eqC, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm font-semibold px-2",
                        children: quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityButton, {
                        onClick: function() {
                            return setQuantity(quantity + 1);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdAdd */.x06, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {
                small: true,
                loading: loading,
                showCaret: false,
                onClick: function() {
                    setIsEditing(true);
                },
                children: t("fields.edit")
            }),
            isEditing && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditProduct, {
                    setLoading: setLoading,
                    cartItemId: item._id,
                    isOpen: isEditing,
                    onClose: function() {
                        return setIsEditing(false);
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Item/Description.tsx





function Description() {
    var ref;
    var item = (0,react.useContext)(ItemContext);
    var darkMode = (0,useIsDarkMode/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex space-x-2",
                children: [
                    (item === null || item === void 0 ? void 0 : item.isOutOfStock) ? "(Agotado)" : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,classnames/* default */.Z)({
                            "text-sm font-semibold": true,
                            "text-gray-400 line-through": item === null || item === void 0 ? void 0 : item.isOutOfStock,
                            "text-gray-800": !darkMode,
                            "text-gray-white": darkMode
                        }),
                        children: item === null || item === void 0 ? void 0 : item.product.name
                    })
                ]
            }),
            (item === null || item === void 0 ? void 0 : (ref = item.descriptionItems) === null || ref === void 0 ? void 0 : ref.length) ? item.descriptionItems.map(function(desc, di) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "font-light text-sm lightTextColor dark:text-gray-200",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: desc.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "list-disc list-inside",
                            children: desc.selections.map(function(selection, si) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: selection
                                }, "".concat(item._id, "_selection_").concat(si));
                            })
                        })
                    ]
                }, "".concat(item._id, "_descriptionItem_").concat(di));
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Item/index.tsx









function Item(param) {
    var item = param.item, onDelete = param.onDelete, _showActions = param.showActions, showActions = _showActions === void 0 ? true : _showActions, _showPrice = param.showPrice, showPrice = _showPrice === void 0 ? true : _showPrice;
    var ref, ref1;
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    var hasDiscount = item.realPrice && item.realPrice !== item.unitPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemContext.Provider, {
        value: item,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col py-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "rounded w-[56px] h-[56px] relative overflow-clip",
                            children: ((ref = item.product) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: item.product.name,
                                layout: "fill",
                                objectFit: "cover",
                                src: item.product.image.url
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,classnames/* default */.Z)({
                                "flex-1 flex flex-col px-3": true,
                                "space-y-2": showPrice && hasDiscount
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {})
                        }),
                        showPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-sm items-end",
                            children: [
                                (0,formatNumber/* default */.Z)(item.unitPrice * item.amount, "money"),
                                hasDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-xs font-light line-through",
                                    children: (0,formatNumber/* default */.Z)(item.realPrice * item.amount, "money")
                                }) : null
                            ]
                        }) : null
                    ]
                }),
                showActions ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex pl-16 ml-1 mt-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions, {
                        onDelete: onDelete
                    })
                }) : null
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/data/mutations/cart/deleteCartItem.ts
var deleteCartItem = __webpack_require__(93865);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/DeleteItem/useDeleteItem.ts
function useDeleteItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDeleteItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDeleteItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDeleteItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useDeleteItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useDeleteItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useDeleteItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










function useDeleteItem(props) {
    var eventBaseProperties = (0,useEventsBaseProperties/* default */.Z)();
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var cartItemId = props === null || props === void 0 ? void 0 : props.cartItemId;
    var item = props === null || props === void 0 ? void 0 : props.item;
    var menuId = props === null || props === void 0 ? void 0 : props.menuId;
    var showMessage = (0,useMessage/* default */.Z)();
    var actionLocation = (0,useAnalyticLocation/* default */.Z)("purchaseEdit");
    var submit = function() {
        var _ref = useDeleteItem_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!loading) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setLoading(true);
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return mutate({
                            mutation: deleteCartItem/* deleteCartItemMutation */.r,
                            variables: {
                                cartItemId: cartItemId
                            },
                            refetchQueries: [
                                "getCartDetails",
                                "getPreferencesForResume",
                                "getCheckoutV3"
                            ]
                        });
                    case 7:
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](4);
                        showMessage("Lo sentimos, no se pudo eliminar el producto del carrito");
                        logger/* default.error */.Z.error("Error deleteItem cartV3", _ctx.t0);
                    case 13:
                        setLoading(false);
                        ;
                        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.productEdited */.F.purchase.productEdited, useDeleteItem_objectSpread({
                            productEditAction: (item === null || item === void 0 ? void 0 : item.amount) === 0 ? "delete" : "edit",
                            productId: (ref1 = item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref._id) !== null && ref1 !== void 0 ? ref1 : "",
                            productAmount: item === null || item === void 0 ? void 0 : item.amount,
                            isAmountEdited: true,
                            isOutOfStock: item === null || item === void 0 ? void 0 : item.isOutOfStock,
                            menuId: menuId !== null && menuId !== void 0 ? menuId : "",
                            actionLocation: actionLocation
                        }, eventBaseProperties));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    9
                ]
            ]);
        }));
        return function submit() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        submit: submit,
        loading: loading
    };
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/DeleteItem/index.tsx
function DeleteItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function DeleteItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                DeleteItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                DeleteItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









function DeleteItem(param) {
    var cartItemId = param.cartItemId, onCancel = param.onCancel, open = param.open;
    var ref, ref1;
    var preferences = (0,usePreferences_main/* default */.Z)().preferences;
    var item1 = (ref = preferences.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
        return item._id === cartItemId;
    });
    var ref2 = useDeleteItem({
        cartItemId: cartItemId,
        item: item1,
        menuId: preferences.menuId
    }), submit = ref2.submit, loading = ref2.loading;
    if (!item1) return null;
    var onDelete = function() {
        var _ref = DeleteItem_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        submit();
                        onCancel();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        forceJustoFont: true,
        hasHeightLimit: true,
        isOpen: open,
        onClose: onCancel,
        headerDivider: true,
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdWarning */.YTL, {
                    className: "text-red-500",
                    size: 32
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-lg font-semibold py-2",
                    children: "\xbfEst\xe1s seguro que quieres eliminarlo?"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col divide-y divide-gray-100 text-sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    showActions: false,
                    showPrice: false,
                    item: item1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-4 py-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: loading,
                            loading: loading,
                            full: true,
                            big: true,
                            danger: true,
                            onClick: onDelete,
                            children: loading ? "" : "S\xed, quiero eliminarlo"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            disabled: loading,
                            full: true,
                            big: true,
                            onClick: onCancel,
                            children: "No, quiero mantenerlo"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/NoItems.tsx


function NoItems() {
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cart"
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "full-w flex-row justify-center text-center p-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "flex-1 break-normal text-base",
                children: t("addProductsToCart")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "flex-1 break-normal font-light text-sm",
                children: t("productsDisplayExplanation")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/V3/Text/TextSkeleton.tsx
var TextSkeleton = __webpack_require__(97417);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Item/Skeleton.tsx


function ItemSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col py-5 animate-pulse",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded w-14 h-14 bg-slate-200 dark:bg-slate-600 mr-3"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1 flex flex-col space-y-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                            type: "body",
                            className: "!h-4 w-4/5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                            type: "body",
                            className: "!h-3 w-3/5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                            type: "body",
                            className: "!h-3 w-3/5"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col text-sm items-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                        type: "body",
                        className: "!h-4 w-16"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/Skeleton.tsx


function CartItemsSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col divide-y divide-solid px-3 overflow-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSkeleton, {})
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartItems/index.tsx
function CartItems_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CartItems_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CartItems_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CartItems_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CartItems_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CartItems_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CartItems_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
















function InnerCartItems() {
    var ref8;
    var cart = (0,useCartDetails_main/* default */.Z)();
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cart"
    }).t;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(null), selectedItem = ref2[0], setSelectedItem = ref2[1];
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var data = (0,getMyOrderPreferencesSlim_main/* useMyOrderPreferencesSlim */.b)(websiteId, {
        partial: false
    }).data;
    var baseEventProperties = (0,useEventsBaseProperties/* default */.Z)();
    (0,react.useEffect)(function() {
        var ref, ref3, ref4;
        var ref5 = ((cart === null || cart === void 0 ? void 0 : cart.items) || []).reduce(function(acc, item) {
            acc.productAmount += item.amount;
            acc.subTotalPrice += item.unitPrice * item.amount;
            return acc;
        }, {
            productAmount: 0,
            subTotalPrice: 0
        }), productAmount = ref5.productAmount, subTotalPrice = ref5.subTotalPrice;
        var ref6, ref7;
        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.cartPageViewed */.F.purchase.cartPageViewed, CartItems_objectSpread({}, baseEventProperties, {
            cartItemsAmount: (ref6 = cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length) !== null && ref6 !== void 0 ? ref6 : 0,
            productAmount: productAmount,
            subTotalPrice: subTotalPrice,
            isScheduledOrder: (data === null || data === void 0 ? void 0 : (ref3 = data.preferences) === null || ref3 === void 0 ? void 0 : ref3.time) !== "now",
            menuId: (ref7 = data === null || data === void 0 ? void 0 : (ref4 = data.preferences) === null || ref4 === void 0 ? void 0 : ref4.menuId) !== null && ref7 !== void 0 ? ref7 : ""
        }));
    }, []);
    var handleDelete = function() {
        var _ref = CartItems_asyncToGenerator(runtime_default().mark(function _callee(cartItemId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return setSelectedItem(cartItemId);
                    case 2:
                        setOpen(true);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDelete(cartItemId) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!cart) return null;
    if (!(cart === null || cart === void 0 ? void 0 : (ref8 = cart.items) === null || ref8 === void 0 ? void 0 : ref8.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoItems, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classnames/* default */.Z)({
                    "flex flex-col divide-y divide-solid px-3 overflow-auto": true,
                    " divide-gray-200": !isDarkMode,
                    " divide-gray-600": isDarkMode
                }),
                children: cart.items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            item: item,
                            onDelete: function() {
                                return handleDelete(item._id);
                            }
                        })
                    }, item._id);
                })
            }),
            open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteItem, {
                cartItemId: selectedItem,
                onCancel: function() {
                    return setOpen(false);
                },
                open: open
            }) : null
        ]
    });
}
function CartItems() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsSkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCartItems, {})
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartResume/Skeleton.tsx


function CartResumeSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col px-2 py-4 justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                        type: "body",
                        className: "!h-4 w-2/5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                        type: "body",
                        className: "!h-4 w-1/5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                        type: "body",
                        className: "!h-4 w-2/5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                        type: "body",
                        className: "!h-4 w-1/5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                        type: "body",
                        className: "!h-4 w-2/5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                        type: "body",
                        className: "!h-4 w-1/5"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/CartResume/index.tsx






function InnerCartResume() {
    var ref;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cart.content.resume"
    }).t;
    var preferences = (0,usePreferencesForResume_main/* default */.Z)();
    var cart = preferences === null || preferences === void 0 ? void 0 : preferences.cart;
    if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length)) return null;
    var totalDiscounts = cart.realPrice - cart.subtotal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col px-2 py-4 justify-between",
        children: [
            totalDiscounts === 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1",
                        children: t("labelProductsTotal")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,formatNumber/* default */.Z)(cart.realPrice, "money")
                    })
                ]
            }),
            totalDiscounts === 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1",
                        children: t("labelDiscountsTotal")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "- ",
                            (0,formatNumber/* default */.Z)(totalDiscounts, "money")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex font-semibold text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1",
                        children: t("labelSubtotal")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,formatNumber/* default */.Z)(cart.subtotal, "money")
                    })
                ]
            })
        ]
    });
}
function CartResume() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartResumeSkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCartResume, {})
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/Skeleton.tsx





function CartContentSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-initial flex-col align-center py-4 border-b",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDeliverySkeleton, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1 overflow-y-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsSkeleton, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-initial flex-col align-center border-t",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartResumeSkeleton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButtonSkeleton, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartContent/index.tsx







function InnerCartContent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-initial flex-col align-center py-4 border-b",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDelivery, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1 overflow-y-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItems, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-initial flex-col align-center border-t",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartResume, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton, {})
                ]
            })
        ]
    });
}
function CartContent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContentSkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCartContent, {})
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartComponent/Skeleton.tsx



function CartComponentSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col h-[74vh] bg-white dark:bg-zinc-800 rounded-lg ml-1 mt-6 mr-0 px-2 py-4 sticky top-5 shadow-[0_0_16px_0_rgba(0,0,0,0.1)]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "px-3 text-lg font-semibold",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSkeleton/* default */.Z, {
                    type: "title"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContentSkeleton, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartComponent/index.tsx





function InnerCartComponent() {
    var ref, ref1;
    var preferences = (0,useCart_main/* default */.Z)();
    var totalItems = preferences === null || preferences === void 0 ? void 0 : (ref = preferences.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.length;
    var suffix = totalItems > 1 ? "s" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col h-[74vh] bg-white dark:bg-zinc-800 rounded-lg ml-1 mt-6 mr-0 px-2 py-4 sticky top-5 shadow-[0_0_16px_0_rgba(0,0,0,0.1)]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "px-3 text-lg font-semibold",
                children: [
                    "Tu Carrito ",
                    totalItems ? "(".concat(totalItems, " producto").concat(suffix, ")") : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContent, {})
        ]
    });
}
function CartComponent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartComponentSkeleton, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCartComponent, {})
    });
};

// EXTERNAL MODULE: ./src/hooks/useURLState/index.ts + 1 modules
var useURLState = __webpack_require__(64105);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartMobile/CartMenuButton/index.tsx






var CartMenuButton_CartButton = function(param) {
    var cart = param.cart;
    var ref;
    var totalItems = (cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length) || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row justify-between w-full text-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdShoppingCart */.kcE, {
                        size: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pl-2",
                        children: [
                            "Carrito (",
                            totalItems,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pl-2",
                    children: (0,formatNumber/* default */.Z)((cart === null || cart === void 0 ? void 0 : cart.subtotal) || 0, "money")
                })
            })
        ]
    });
};
function CartMenuButton(props) {
    var ref;
    var onClick = props.onClick;
    var preferences = (0,useCart_main/* default */.Z)();
    var cart = preferences.cart;
    if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-4 z-50 fixed w-full bottom-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            primary: true,
            full: true,
            big: true,
            onClick: onClick,
            className: "flex flex-row button-v3-primary h-14 font-sans rounded-md shadow-[0_0_16px_0_rgba(0,0,0,0.25)]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMenuButton_CartButton, {
                cart: cart
            })
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/DeliveryHeaderMobile/index.tsx
var DeliveryHeaderMobile = __webpack_require__(19544);
;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartMobile/CartModal/index.tsx



function CartModal(props) {
    var isOpen = props.isOpen, setOpen = props.setOpen;
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        onClose: function() {
            setOpen(false);
        },
        isOpen: isOpen,
        compact: true,
        className: "rounded-t-lg dark:bg-zinc-800",
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "px-3 text-xl font-semibold",
            children: "Tu Carrito"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col h-[85vh] px-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContent, {})
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartMobile/index.tsx
function CartMobile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CartMobile_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CartMobile_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CartMobile_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CartMobile_slicedToArray(arr, i) {
    return CartMobile_arrayWithHoles(arr) || CartMobile_iterableToArrayLimit(arr, i) || CartMobile_unsupportedIterableToArray(arr, i) || CartMobile_nonIterableRest();
}
function CartMobile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CartMobile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CartMobile_arrayLikeToArray(o, minLen);
}









function InnerCartMobile() {
    var ref = CartMobile_slicedToArray((0,useURLState/* default */.Z)("seeTableOrder"), 2), seeTableOrder = ref[0], setSeeTableOrder = ref[1];
    var isOpenQueryParam = seeTableOrder === "true";
    var ref1 = (0,react.useState)(isOpenQueryParam), open = ref1[0], setOpen = ref1[1];
    (0,react.useEffect)(function() {
        if (!open && isOpenQueryParam) setSeeTableOrder("false");
    }, [
        open,
        isOpenQueryParam
    ]);
    (0,react.useEffect)(function() {
        if (isOpenQueryParam) setOpen(true);
    }, [
        isOpenQueryParam,
        seeTableOrder
    ]);
    (0,react_app_events_lib/* useOnEvent */.dh)("setOpenCartMobile", function(value) {
        setOpen(value);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryHeaderMobile["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(useCartModalContext.Provider, {
                value: {
                    closeModal: function() {
                        return setOpen(false);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMenuButton, {
                        onClick: function() {
                            return setOpen(!open);
                        }
                    }),
                    open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartModal, {
                        isOpen: open,
                        setOpen: setOpen
                    }) : null
                ]
            })
        ]
    });
}
function CartMobile() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
        fallback: null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCartMobile, {})
    });
};

// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/OptionsLabel/index.tsx
var OptionsLabel = __webpack_require__(3306);
// EXTERNAL MODULE: ./node_modules/react-click-outside/build/index.js
var build = __webpack_require__(48683);
// EXTERNAL MODULE: ./src/hooks/useDisableScroll.ts
var useDisableScroll = __webpack_require__(1287);
;// CONCATENATED MODULE: ./src/components/V3/SideModal/index.tsx





function SideModal(props) {
    var title = props.title, onClose = props.onClose, open = props.open, children = props.children, _canClickOutside = props.canClickOutside, canClickOutside = _canClickOutside === void 0 ? true : _canClickOutside;
    (0,useDisableScroll/* default */.Z)(open);
    if (!open) return null;
    var onClickOutside = function() {
        if (!canClickOutside || document.getElementById("close-modal-product") || document.getElementById("v3_modal")) {
            // This is hacky, but couldn't think of a better way to prevent the click outside when there are two modals open
            return;
        }
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-[1100]",
        "aria-labelledby": "slide-over-title",
        role: "dialog",
        "aria-modal": "true",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-events-auto relative w-screen max-w-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(build/* default */.Z, {
                                onClickOutside: onClickOutside,
                                className: "flex h-screen flex-col bg-white dark:bg-zinc-800 px-6 py-6 shadow-xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-2xl font-semibold",
                                                id: "slide-over-title",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "cursor-pointer",
                                                "aria-label": "Close button",
                                                onClick: onClose,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdClose */.FU5, {
                                                    size: 24
                                                })
                                            })
                                        ]
                                    }),
                                    children
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartSidebar/ContentWrapper/index.tsx



function ContentWrapper(props) {
    var open = props.open, onClose = props.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SideModal, {
        title: "Tu carrito",
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContent, {})
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/CartSidebar/index.tsx












function InnerCartSidebar() {
    var preferences = (0,useCart_main/* default */.Z)();
    var cart = preferences.cart;
    var ref;
    var total = (ref = cart === null || cart === void 0 ? void 0 : cart.itemsPrice) !== null && ref !== void 0 ? ref : 0;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(false), openAddress = ref2[0], setOpenAddress = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed sticky top-0 left-0 right-0 z-[300] w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "primaryBackgroundColor",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        className: "flex flex-row justify-between primaryBackgroundColor h-12 items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return setOpenAddress(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.Z, {
                                    className: "text-base secondaryBackgroundColor primaryColor text-base !px-2 !py-1 !rounded",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsLabel/* default */.Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row orion_primary cursor-pointer items-center",
                                onClick: function() {
                                    if (!(preferences === null || preferences === void 0 ? void 0 : preferences.storeId)) {
                                        setOpenAddress(true);
                                        return;
                                    }
                                    setOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center items-center font-bold",
                                        children: cart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                            value: total
                                        }) : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex-1 px-2 text-xs",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdShoppingBasket */.Kvb, {
                                            size: 18,
                                            "aria-label": "cart"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(useCartModalContext.Provider, {
                value: {
                    closeModal: function() {
                        return setOpen(false);
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                    open: open,
                    onClose: function() {
                        return setOpen(false);
                    }
                })
            }),
            openAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryWizard/* default.AsModal */.Z.AsModal, {
                isOpen: openAddress,
                onClose: function() {
                    return setOpenAddress(false);
                },
                actionLocation: "cart"
            }) : null
        ]
    });
}
function CartSidebar() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
        fallback: null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerCartSidebar, {})
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/CartV3/index.tsx



var CartV3 = {
    AsMobile: CartMobile,
    AsComponent: CartComponent,
    AsSidebar: CartSidebar
};
/* harmony default export */ var Order_CartV3 = (CartV3);

// EXTERNAL MODULE: ./src/hooks/useIsStore.ts + 2 modules
var useIsStore = __webpack_require__(68400);
;// CONCATENATED MODULE: ./src/page-components/Order/LongOrCompactLayout.tsx



var LongOrCompactCPG = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6653), __webpack_require__.e(7800), __webpack_require__.e(5267), __webpack_require__.e(6569), __webpack_require__.e(1204)]).then(__webpack_require__.bind(__webpack_require__, 57476));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57476)
            ];
        }
    }
});
var Products = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6653), __webpack_require__.e(7800), __webpack_require__.e(5267), __webpack_require__.e(6569), __webpack_require__.e(5693)]).then(__webpack_require__.bind(__webpack_require__, 68156));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68156)
            ];
        }
    }
});
function LongOrCompactLayout(props) {
    var nextOpenDate = props.nextOpenDate;
    var isStore = (0,useIsStore/* default */.Z)();
    return isStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LongOrCompactCPG, {
        nextOpenDate: nextOpenDate
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, {});
};

// EXTERNAL MODULE: ./src/page-components/Order/useLayout.ts
var useLayout = __webpack_require__(88641);
// EXTERNAL MODULE: ./src/page-components/Order/useProductsLayout.ts
var useProductsLayout = __webpack_require__(66218);
// EXTERNAL MODULE: ./src/page-components/Order/styles.module.css
var styles_module = __webpack_require__(43872);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/index.tsx
function Order_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Order_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Order_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

























var PageMeta = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8264).then(__webpack_require__.bind(__webpack_require__, 98264));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98264)
            ];
        }
    },
    ssr: false
});
var Page = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4231).then(__webpack_require__.bind(__webpack_require__, 57907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57907)
            ];
        }
    },
    ssr: false
});
var Cart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6011), __webpack_require__.e(8102), __webpack_require__.e(700), __webpack_require__.e(4847)]).then(__webpack_require__.bind(__webpack_require__, 45603));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45603)
            ];
        }
    }
});
var CartMenuV2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8423), __webpack_require__.e(8102), __webpack_require__.e(700), __webpack_require__.e(6416), __webpack_require__.e(9556)]).then(__webpack_require__.bind(__webpack_require__, 16416));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16416)
            ];
        }
    }
});
var CategoriesLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6653), __webpack_require__.e(5267), __webpack_require__.e(4368), __webpack_require__.e(637)]).then(__webpack_require__.bind(__webpack_require__, 16984));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16984)
            ];
        }
    }
});
var NextOpenDate = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9230).then(__webpack_require__.bind(__webpack_require__, 79230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79230)
            ];
        }
    }
});
var NoMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3859).then(__webpack_require__.bind(__webpack_require__, 83859));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83859)
            ];
        }
    }
});
var Options = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5119).then(__webpack_require__.bind(__webpack_require__, 75119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75119)
            ];
        }
    }
});
var Order_DeliveryHeaderMobile = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 19544));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19544)
            ];
        }
    }
});
var CreateAddress = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 21620));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21620)
            ];
        }
    },
    ssr: false
});
var CreateAddressInstructions = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8708).then(__webpack_require__.bind(__webpack_require__, 38708));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38708)
            ];
        }
    },
    ssr: false
});
function Order(props) {
    var ref11, ref1, ref2, ref3, ref4, ref5;
    var productId = props.productId, page = props.page, componentIdToSsrProps = props.componentIdToSsrProps;
    var ref6 = (0,websiteMenuInformation_main/* useWebsiteMenuInformation */.g9)(), website = ref6.website, design = ref6.design;
    var router = (0,next_router.useRouter)();
    var ref7 = (0,getMyOrderPreferencesSlim_main/* useMyOrderPreferencesSlim */.b)(website._id), data = ref7.data, networkStatus = ref7.networkStatus;
    var loading = networkStatus !== 7;
    var ref8;
    var menuId = ((ref8 = data === null || data === void 0 ? void 0 : data.preferences) !== null && ref8 !== void 0 ? ref8 : {}).menuId;
    var layout = (0,useLayout/* default */.Z)();
    var productsLayout = (0,useProductsLayout/* default */.Z)(website);
    var countryCode = (0,useCountryCode/* default */.Z)();
    var isCartV3 = (0,useCartV3/* default */.Z)();
    var useAddressInstructionsModal = useWebsiteAddressInstructionModal();
    var ref9 = (0,react.useState)(false), modalOpen = ref9[0], setModalOpen = ref9[1];
    var needCookies = (0,doesCountryRequireCookies/* default */.Z)(countryCode);
    var eventBaseProperties = (0,useEventsBaseProperties/* default */.Z)();
    var ref10 = (0,react.useState)(useAddressInstructionsModal && (!needCookies || needCookies && layout !== "mobile") && !(data === null || data === void 0 ? void 0 : (ref11 = data.preferences) === null || ref11 === void 0 ? void 0 : ref11.storeId)), instructionsModalOpen = ref10[0], setInstructionsModalOpen = ref10[1];
    (0,react.useEffect)(function() {
        var ref;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.preferences) === null || ref === void 0 ? void 0 : ref._id)) return;
        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.browse.orderPageViewed */.F.browse.orderPageViewed, Order_objectSpread({
            menulayoutDesign: website.menuLayout,
            productCardDesign: design === null || design === void 0 ? void 0 : design.design.productCardDesign,
            menuId: menuId !== null && menuId !== void 0 ? menuId : ""
        }, eventBaseProperties));
    }, [
        data === null || data === void 0 ? void 0 : (ref1 = data.preferences) === null || ref1 === void 0 ? void 0 : ref1._id
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.addressModal) {
            router.replace({
                pathname: "/pedir",
                query: {}
            });
        }
    }, [
        (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.addressModal
    ]);
    if (!website.deliveryTypes) return null;
    if (!website.deliveryTypes.length) return null;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).loadingContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {})
        });
    }
    if (!menuId) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMenu, {});
    var nextOpenDate = /*#__PURE__*/ (0,jsx_runtime.jsx)(NextOpenDate, {
        deliverAt: (ref3 = data.preferences) === null || ref3 === void 0 ? void 0 : ref3.deliverAt,
        storeId: (ref4 = data.preferences) === null || ref4 === void 0 ? void 0 : ref4.menuId
    });
    var products = productsLayout === "categories" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesLayout, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LongOrCompactLayout, {
        nextOpenDate: nextOpenDate
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartLoadingContext/* CartLoadingProvider */.RI, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).container,
                children: [
                    instructionsModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateAddressInstructions, {
                        isOpen: instructionsModalOpen,
                        setOpen: setInstructionsModalOpen,
                        setOpenAddressModal: setModalOpen
                    }),
                    modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateAddress, {
                        isOpen: modalOpen,
                        onClose: function() {
                            return setModalOpen(false);
                        }
                    }),
                    page ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                        pageId: page._id,
                        page: page,
                        componentIdToSsrProps: componentIdToSsrProps
                    }) : null,
                    layout === "mobile" && !isCartV3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_DeliveryHeaderMobile, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).mobileMarginTop
                            })
                        ]
                    }) : null,
                    layout === "mobile" && isCartV3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_CartV3.AsMobile, {}) : null,
                    layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isCartV3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_CartV3.AsSidebar, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-12 bg-gray-400 animate-pulse"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMenuV2, {
                                loading: loading
                            })
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            ((ref5 = data.preferences) === null || ref5 === void 0 ? void 0 : ref5.storeId) && layout !== "v2" ? nextOpenDate : null,
                            layout === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
                                    children: products
                                })
                            }) : null,
                            layout === "v1" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-xs-12 col-sm-6 col-md-4 last-sm",
                                        children: [
                                            isCartV3 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {}),
                                            isCartV3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Order_CartV3.AsComponent, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsContent_Loading/* default */.Z, {}),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-xs-12 col-sm-6 col-md-8",
                                            children: products
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsContent_Loading/* default */.Z, {
                            fullScreen: true
                        }),
                        children: products
                    }) : null,
                    productId ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta, {})
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/_sites/[mobileOrDesktop]/[hostname]/order/index.tsx










var __N_SSG = true;
/**
 * Important note:
 * This page is shared between multiple routes (order, category, product and conversational-commerce routes).
 * To enable this magic, read src/helpers/middleware/sharedPages/index.ts
 */ function OrderPage(props) {
    var router = (0,useSharedPageRewriteHelper/* default */.Z)("productId", getProductIdFromOrderUrl);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SsgFallback/* default */.Z, {});
    }
    if (!props.website) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWebsite["default"], {});
    }
    if (props.website.isDeactivatedByDebt) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeactivatedByDebt/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AbstractLayout/* default */.Z, {
        LayoutComponent: Website["default"],
        initialData: props.initialData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(websiteMenuInformation_main/* WebsiteMenuInformationProvider */.g_, {
            websiteMenuInfo: {
                website: props.website,
                design: props.design
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Order, {
                page: props.page,
                componentIdToSsrProps: props.componentIdToSsrProps,
                productId: Array.isArray(router.query.productId) ? router.query.productId[0] : router.query.productId
            })
        })
    });
};


/***/ }),

/***/ 80805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2k40sP--bs7-ORleL6riGA","loading":"_2eozYEUmcZzMsjXiI6UIu6"};

/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dzszu0edT56nvw27R-vYR loadingGlow"};

/***/ }),

/***/ 43469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uvgfwBWaWQqFyLab9Dtip","image":"hS9SabcUKdHLsU7xUWYeA","title":"_3zsZZ1G9oclG4rKZNszc97","logo":"_1EDR5Wb9Y0TBlQji0Ya33U"};

/***/ }),

/***/ 64321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_25TFeypo-VC6x_SRlhBUCq","loading":"_3oTnjcuokOSL6m44hTNfcL loadingGlow"};

/***/ }),

/***/ 43872:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2bEeEQNpv9yvXBBvEmpfOH orderMainContainer","mobileMarginTop":"_1Y1ns8DNZhwPZ5az9jD21B","loadingContainer":"_3-H9UEsWuWJy9oTqpF_DKH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3662,5445,9866,5990,6907,4053,6350,1470,4078,1964,3067,4356,6970,191,939,7502,6665,937,433,4761,1047,4495,801,151,7362,6312,1683,9774,2888,179], function() { return __webpack_exec__(9695); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);